import React from "react"
import { TextField } from "@mui/material"
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider"
import { AdapterLuxon } from "@mui/x-date-pickers/AdapterLuxon"
import { DateTime } from "luxon"
import { merge } from "lodash"
import { DesktopDateTimePicker } from "@mui/x-date-pickers"

function CustomDateTimePicker(props) {
    const {
        InputAdornmentProps,
        InputProps: userInputProps,
        value,
        label,
        date1,
        date2,
        onChange,
        ...otherUserProps
    } = props
    return (
        <LocalizationProvider dateAdapter={AdapterLuxon}>
            <DesktopDateTimePicker
                disableMaskedInput
                label={label}
                value={value ? DateTime.fromISO(value) : null}
                minDate={
                    date2 ? DateTime.fromISO(date2) || new Date() : undefined
                }
                maxDate={
                    date1 ? DateTime.fromISO(date1) || new Date() : undefined
                }
                onChange={() => true}
                {...InputAdornmentProps}
                onAccept={(newValue) => {
                    onChange(newValue?.toString())
                }}
                renderInput={({ InputProps, ...rest }) => (
                    <TextField
                        InputProps={merge(InputProps, userInputProps)}
                        {...otherUserProps}
                        {...rest}
                    />
                )}
            />
        </LocalizationProvider>
    )
}

export default CustomDateTimePicker
